export const styles = ({
    container: {
        fontWeight: 500,
        marginBottom: 16
    }
});
